import React from 'react';
import { Handle } from './styled';
import DragIcon from '@icons/common/drag.svg';

// deaults to 0 opacity
// override on component hover action with drag-handle classname
function DragHandle(props) {
  return (
    <Handle className="drag-handle" {...props}>
      <DragIcon />
    </Handle>
  )
}

export default DragHandle;
